/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { LiveManagementViewLivecarpResponse } from './LiveManagementViewLivecarpResponse';

export type LiveManagementViewLivecarpResponseApiRespoonse = {
    data?: LiveManagementViewLivecarpResponse;
    status?: LiveManagementViewLivecarpResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace LiveManagementViewLivecarpResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

